import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useResetScroll from "../../utils/useResetScroll";
import RenderTranslatedText from "../../components/RenderTranslatedText";

const Contact = () => {
  useResetScroll();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSendEmail = () => {
    if (!email.trim() || !message.trim()) {
      alert("Please fill in all fields.");
      return;
    }
  
    const subject = encodeURIComponent("User Query");
    const body = encodeURIComponent(`From: ${email}\n\nMessage:\n${message}`);
    const mailtoLink = `mailto:otalife.contact@gmail.com?subject=${subject}&body=${body}`;
    
    window.location.href = mailtoLink;
  };

  return (
    <div className="max-w-[450px] mx-auto p-5 flex flex-col items-center min-h-[100svh] otaPageBg">
      <p className="otaDark text-[24px] font-bold text-center my-10 mt-18">
        <RenderTranslatedText i8nKey={"Contact Us"} />
      </p>
      <input
        type="email"
        placeholder="Your Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="w-full p-2 border rounded-xl mb-3"
        required
      />
      <textarea
        placeholder="Your Message"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        className="w-full p-2 border rounded-xl mb-3 h-24"
        required
      />
      <button
        onClick={handleSendEmail}
        className="text-blue-500 text-sm text-center rounded-xl font-medium border-2 w-full border-blue-500 p-2 mb-2 bg-white mx-4"
      >
        <RenderTranslatedText i8nKey={"Send Message"} />
      </button>
      <p className="text-sm text-center italic">
          or directly email us at {" "}
        </p>
          <a 
            href="mailto:otalife.contact@gmail.com?subject=User%20Query&body=Please%20share%20your%20message%20here." 
            className="text-sm text-blue-500 hover:underline italic"
          >
              otalife.contact@gmail.com
          </a>
    </div>
  );
};

export default Contact;
